
<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

    <v-layout>
      <v-flex>
        <h4 style="color: white;">Non-Checkoff Account</h4>
        <v-card>
            <div class="grower-name">
              <strong>Grower Name:</strong> Chavavo Farmer Society
            </div>
            <div class="account-details">
              <div class="account-no">
                <span>DSS Settlement Account Number:</span>
                <span>{{ accountNumber }}</span>
              </div>
              <div class="account-name">
                <span>DSS Settlement Account Name:</span>
                <span>{{ accountName }}</span>
              </div>
              <div class="account-bookbalance">
                <span>Book Balance:</span>
                <span>{{ bookBalance }}</span>
              </div>
            </div>
            <!-- <div class="search-transactions">
              <h4>Search for Transactions</h4>
              <div class="form-group">
                <div class="input-group">
                  <label for="transaction-id" >Tran ID</label>
                  <select id="transaction-id"  v-model="transactionId">
                    <option value="AAAB3D27ED21">AAAB3D27ED21</option>
                  </select>
                </div>
                <div class="input-group">
                  <label for="from-date">From</label>
                  <input type="date" id="from-date" v-model="fromDate" placeholder="01 - 01 - 2024">
                </div>
                <div class="input-group">
                  <label for="to-date">To</label>
                  <input type="date" id="to-date" v-model="toDate" placeholder="31 - 01 - 2024">
                </div>
                <button class="btn search-btn">Search</button>
                <button class="btn download-btn">Download</button>
              </div>
            </div> -->
            <div class="search-transactions">
              <h4>Search for Transactions</h4>
              <div class="form-group">
                <div class="input-group">
                  <label for="transaction-id">Tran ID</label>
                  <select id="transaction-id">
                    <option value="AAAB3D27ED21">AAAB3D27ED21</option>
                  </select>
                </div>
                <div class="input-group">
                  <label for="from-date">From</label>
                  <input type="date" id="from-date" placeholder="01 - 01 - 2024">
                </div>
                <div class="input-group">
                  <label for="to-date">To</label>
                  <input type="date" id="to-date" placeholder="31 - 01 - 2024">
                </div>
                <button class="btn search-btn">Search</button>
                <button class="btn download-btn">Download</button>
              </div>
            </div>
          <table class="stock-table">
            <thead>
              <tr>
                <th>Transaction Date</th>
                <th>Transaction ID</th>
                <th>Narration</th>
                <th>Amount (KES)</th>
                <th>DR/CR</th>
                <th>Running Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in transactions" :key="transaction.id">
                <td>{{ transaction.date }}</td>
                <td>{{ transaction.id }}</td>
                <td>{{ transaction.narration }}</td>
                <td>{{ transaction.amount }}</td>
                <td>{{ transaction.drCr }}</td>
                <td>{{ transaction.runningBalance }}</td>
              </tr>
            </tbody>
          </table>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

export default {
	name: 'growernoncheckoffaccstmt',

	data: function () {
		return {
			selectedTab: null,
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
      paginatedItems: [],
      permissions: [],
      accountNumber: "110111200303",
      accountName: "Chavavo Farmer Society",
      bookBalance: "$22,344",
      searchBy: "transactionID",
      searchValue: "AAAB3D27ED21",
      startDate: "2024-01-01",
      endDate: "2024-01-31",
      transactionId: 'AAAB3D27ED21',
      fromDate: '01 - 01 - 2024',
      toDate: '31 - 01 - 2024',
      transactions: [
        {
          id: "AAAB3D27ED21",
          date: "22-02-2024 11:34:39 AM",
          narration: "MERU COUNTY COFFEE MILLERS CO-OPERATIVE UNION LTD_clean_160_2022_2023",
          amount: "KES 120,000.00",
          drCr: "CR",
          runningBalance: "KES 400,000.00",
        },
      ],
      numberOfLinks: 0,
      numberOfItemsPerPage: 7,
      currentPage: 0,
      page: 1

		}
	},
  methods: {
    searchTransactions() {
      // Add search logic here...
    },
    downloadTransactions() {
      // Add download logic here...
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        // Add logic to handle page change...
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        // Add logic to handle page change...
      }
    },

}
}
</script>
<style scoped>
.search-section {
  margin: 20px 0;
  padding: 10px;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-bar input {
  padding: 5px;
}
.table_area_box_empty {
  position: relative;
  background: #fff;
  overflow-x: auto;
  /* //border: 1px solid #707070; */
}

.table_area_box {
  position: relative;
  background: #fff;
  overflow-x: auto;
/* //border: 1px solid #707070; */
  
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

.table {
  overflow-x: auto;
}

td {
  max-width: 200px; /* Set a maximum width for cells */
  overflow: hidden;
  text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
  white-space: nowrap; /* Prevent text from wrapping */

}

/*
search
*/
.stock-status-grade {
  display: flex;
  height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #004d25;
  color: #fff;
}

.logo img {
  height: 40px;
}

.title {
  font-size: 24px;
  font-weight: bold;
}

.user-profile {
  display: flex;
  align-items: center;
}

.user-profile img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.sidebar {
  width: 200px;
  background-color: #e9f5f1;
  padding: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  padding: 10px 0;
  font-weight: bold;
}

.sidebar .active {
  color:#004d25;
}

.content {
  flex: 1;
  padding: 20px;
}

.search-bar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.search-bar label {
  margin-right: 10px;
}

.search-bar select {
  padding: 5px;
  margin-right: 10px;
}

.search-bar button {
  background-color:#004d25;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
}

.stock-table {
  width: 100%;
  border-collapse: collapse;
}

.stock-table th, .stock-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.stock-table th {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.stock-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.stock-table tr:last-child td {
  font-weight: bold;
  color: rgb(13, 12, 12);
  font-size: 12px;
}
.search-bar {
  display: flex;
  justify-content: space-between;  
  gap: 20px;
}

.label-wrapper {
  display: flex;
  align-items: center;
}

.label-wrapper {
  margin-right: -1px; /* Adjust to ensure no gap between label and input */
}

.custom-label {
  background-color: #f0f0f0; /* Greyish background color */
  color: #333; /* Text color */
  padding: 10px 15px; /* Padding inside the label */
  border-radius: 15px 15px 15px 15px; /* Slightly curved on the left side */
  font-size: 16px; /* Font size */
  font-weight: bold; /* Optional: makes the text bold */
  display: inline-block; /* Allows the label to fit its content */
  white-space: nowrap; /* Prevents label from wrapping to the next line */
}
input[type="text"] {
  padding: 10px 15px; /* Padding inside the input */
  border: 1px solid #ccc; /* Border color */
  border-radius: 15px 15px 15px 15px; /* Slightly curved on the right side */
  font-size: 16px; /* Font size */
  box-sizing: border-box; /* Ensures padding and border are included in width calculation */
  outline: none; /* Removes the default focus outline */
}
.grower-code-select {
  background-color: #dde7e4 !important;
  width: 200px; /* Adjust width as needed */
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}
.non-checkoff-account {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Adjust the height as needed */
}

.grower-name {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.account-details {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns of equal width */
  grid-template-rows: auto auto; /* Two rows */
  gap: 10px; /* Space between rows and columns */
  border: 1px solid #ccc; /* Greyish border */
  padding: 0px;
  font-weight: bold; /* Make all items bold */
  text-align: left;
  width: 1000px;
  margin: 10px auto; /* 100px margin on top and bottom, auto centers left and right */
  background-color: #f9f9f9; /* Optional: Add a background color to make the div visible */
  padding: 0px; /* Optional: Add padding inside the div */
  border: 1px solid #ccc; /* Optional: Add a border to the div */
}

.account-details div {
  padding: 10px;
  /*border: 1px solid #ccc;  Greyish border for each item */
}

.account-no span,
.account-name span,
.account-bookbalance span {
  display: inline-block;
  margin-right: 10px; /* Optional: Adds space between the spans */
}
.search-transactions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 60px; 
  margin-right: 0px;
}

h4 {
  font-size: 16px;
  margin-bottom: 15px;
}

.form-group {
  display: flex;
  align-items: center; 
}

.input-group {
  display: flex;
  align-items: center;
  margin-right: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}
.search-transactions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

h4 {
  font-size: 16px;
  margin-bottom: 15px;
}

.form-group {
  display: flex;
  align-items: center;
}

.input-group {
  display: flex;
  align-items: center;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.input-group label {
  background-color: #f2f2f2;
  padding: 10px 15px;
  font-weight: 500;
  font-size: 14px;
  border-right: 1px solid #ddd;
}

.input-group input {
  border: none;
  padding: 10px;
  font-size: 14px;
}

.input-group select {
  border: none;
  padding: 10px;
  background-color: #f9fdf9;
  font-size: 12px;
  width: 180px;
}
.input-group {
  display: flex;
  align-items: center;
}

.input-group label {
  margin-right: 8px; /* Adjust spacing between label and select as needed */
}
.input-group .calendar-icon {
  font-size: 16px;
  margin-left: 8px;
  padding-right: 10px;
  color: #4CAF50;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 10px;
}

.search-btn {
  background-color: #004d40;
  color: white;
}

.download-btn {
  background-color: #4CAF50;
  color: white;
}

.search-btn {
  background-color: #004d40;
  color: white;
}

.download-btn {
  background-color: #4CAF50;
  color: white;
}
</style>